import React, { useState, useContext } from 'react'
import moment from 'moment'
import { get } from 'lodash'
import {
  Modal,
  Form,
  Input,
  InputNumber,
  Select,
  // DatePicker,
  Checkbox,
  Button,
} from 'antd'
import { AppContext } from 'AppContext'
import { canUserEdit, canUserAdd, canUserSave } from 'utils/User'

const { Option } = Select

const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]

const CollectionCreateForm = ({
  visible,
  onCreate,
  onCancel,
  loading,
  isUpdate,
  onUpdate,
  amount,
  data,
  date,
}) => {
  const [isMultiple, setIsMultiple] = useState(false)
  const [selectedMonth, setSelectedMonth] = useState(false)
  date = date ? moment() : moment(date)
  if (get(data, 'client.id')) {
    data.clientId = get(data, 'client.id')
  }

  const [form] = Form.useForm()

  const {
    state: { currentUser, userPermissions, isClient } = {},
  } = useContext(AppContext) || {}

  const hasEditPermission = canUserEdit(userPermissions || currentUser, isClient)
  const hasAddPermission = canUserAdd(userPermissions || currentUser, isClient)
  const hasSavePermission = canUserSave(userPermissions || currentUser, isClient)

  const canSubmit = isUpdate
    ? (hasEditPermission && hasSavePermission)
    : (hasAddPermission && hasSavePermission)
  const isReadOnly = isUpdate ? !hasEditPermission : !hasAddPermission

  function resetForm() {
    form.resetFields()
  }

  const paymentTypes = [
    { text: 'CASH', value: 'CASH' },
    { text: 'CHEQUE', value: 'CHEQUE' },
    { text: 'ONLINE', value: 'ONLINE' },
  ]

  const statusTypes = [
    { text: 'PENDING', value: 'PENDING' },
    { text: 'COMPLETED', value: 'COMPLETED' },
  ]

  const year = moment()
  const status = 'COMPLETED'
  const whichMonth = year.format('MMMM')

  return (
    <Modal
      className='feedback_form'
      maskClosable={false}
      visible={visible}
      title={isUpdate ? 'Update SIP' : 'Create SIP'}
      okText={isUpdate ? 'Update' : 'Create'}
      okButtonProps={{
        loading,
        disabled: !canSubmit,
      }}
      cancelText='Cancel'
      onCancel={() => {
        resetForm()
        onCancel()
      }}
      onOk={() => {
        if (!canSubmit) return
        form
          .validateFields()
          .then((values) => {
            if (isUpdate) {
              onUpdate(values, resetForm)
            } else {
              onCreate(values, resetForm)
            }
          })
          .catch((info) => console.log('Validate Failed:', info))
      }}
    >
      <Form
        form={form}
        layout='vertical'
        name='form_in_modal'
        initialValues={{
          date,
          year,
          status,
          amount,
          whichMonth,
          modifier: 'public',
          ...data,
        }}
        onFinish={() => {
          if (!canSubmit) return
          form
            .validateFields()
            .then((values) => {
              if (isUpdate) {
                onUpdate(values, resetForm)
              } else {
                onCreate(values, resetForm)
              }
            })
            .catch((info) => console.log('Validate Failed:', info))
        }}
      >
        <fieldset
          disabled={isReadOnly}
          style={{ border: 0, padding: 0, margin: 0 }}
        >
        <Form.Item
          name='amount'
          label='Amount'
          rules={[{ required: true, message: 'Please input your Amount!' }]}
        >
          <InputNumber
            min={0}
            style={{ width: '100%' }}
            placeholder='Enter Amount'
          />
        </Form.Item>
        {!isUpdate && (
          <Form.Item name='multiple'>
            <Checkbox
              onChange={() => {
                setIsMultiple(!isMultiple)
                form.setFieldsValue({
                  multiple: !isMultiple,
                })
              }}
            >
              Multiple
            </Checkbox>
          </Form.Item>
        )}
        {isMultiple && (
          <Form.Item
            name='whichMonthFrom'
            label='From Month'
            rules={[
              { required: true, message: 'Please Select from Which Month!' },
            ]}
          >
            <Select
              placeholder='Select From Month'
              getPopupContainer={(trigger) => trigger.parentElement}
              onChange={(e) => {
                setSelectedMonth(months.findIndex((m) => m === e) + 1)
                form.setFieldsValue({
                  whichMonthTo: undefined,
                })
              }}
            >
              {months.map((month) => (
                <Option key={month} value={month}>
                  {month}
                </Option>
              ))}
            </Select>
          </Form.Item>
        )}

        {isMultiple && (
          <Form.Item
            name='whichMonthTo'
            label='To Month'
            rules={[
              { required: true, message: 'Please Select to Which Month!' },
            ]}
            notFoundContent='Please Select from month First!'
          >
            <Select getPopupContainer={(trigger) => trigger.parentElement} placeholder='Select To Month'>
              {!!selectedMonth &&
                months.slice(selectedMonth, months.length + 1).map((month) => (
                  <Option key={month} value={month}>
                    {month}
                  </Option>
                ))}
            </Select>
          </Form.Item>
        )}

        {!isMultiple && (
          <Form.Item
            name='whichMonth'
            label='Month Of'
            rules={[
              { required: true, message: 'Please input your Which Month!' },
            ]}
          >
            <Select getPopupContainer={(trigger) => trigger.parentElement} placeholder='Select Month'>
              {months.map((month) => (
                <Option key={month} value={month}>
                  {month}
                </Option>
              ))}
            </Select>
          </Form.Item>
        )}
        <Form.Item
          name='paymentType'
          label='Select Payment Type'
          rules={[
            {
              required: true,
              message: 'Please Select Payment Type!',
              whitespace: true,
            },
          ]}
        >
          <Select getPopupContainer={(trigger) => trigger.parentElement} placeholder='Select Payment Type'>
            {paymentTypes.map((paymentType) => (
              <Option key={paymentType.value} value={paymentType.value}>
                {paymentType.text}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          name='status'
          label='Select Status Type'
          rules={[
            {
              required: true,
              message: 'Please Select Status Type!',
              whitespace: true,
            },
          ]}
        >
          <Select getPopupContainer={(trigger) => trigger.parentElement} placeholder='Select Status Type'>
            {statusTypes.map((statusType) => (
              <Option key={statusType.value} value={statusType.value}>
                {statusType.text}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          hasFeedback
          name='description'
          label='Description'
          rules={[
            {
              required: true,
              message: 'Please write your description!',
              whitespace: true,
            },
          ]}
        >
          <Input.TextArea rows={5} />
        </Form.Item>
        {/* <Form.Item name='date' style={{ display: 'none' }}>
          <DatePicker format={'DD-MMM-YYYY'} />
        </Form.Item> */}
        </fieldset>

        <div className='footer-btn-div'>
          <Button
            className='footer-cancel-btn'
            onClick={() => {
              resetForm()
              onCancel()
            }}
          >
            Cancel
          </Button>
          <Button
            htmlType='submit'
            className='footer-submit-btn'
            type='primary'
            loading={loading}
            disabled={!canSubmit}
          >
            {isUpdate ? 'Update' : 'Create'}
          </Button>
        </div>
      </Form>
    </Modal>
  )
}

const CreateTicketModal = (props) => {
  return (
    <div>
      <CollectionCreateForm {...props} />
    </div>
  )
}

export default CreateTicketModal
